/* Ayudate · Punto de entrada
   Lo único que hace es montar App dentro del <div id="root"> del index.html.
   No lleva estilos: cada página carga los suyos desde src/estilos/.        */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
